import React from 'react'
import '../css/Landing.css'


function Landing() {
    return (
        <div className='landing-container'>
            <div className='landing-content'>
                <h1>We are Save the Animals</h1>
                <p>Our goal is to help conservationists receive critical funding and increased global support through an app that provides real-time updates on day-to-day campaigns.</p>
                <p>We can stop global extinction if we utilize new technology and interact with supporters in ways that they want!</p>
            </div>
        </div>
    )
}



export default Landing
